module.exports = __webpack_public_path__ + "static/media/fb-grey.a7697234.svg";